import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  filters: [],
  data: {},
  locationCode: null
};

const fetchReviewRequest = (state) => ({
  ...state,
  loading: true
});

const fetchReviewSuccess = (state, action) => ({
  ...state,
  loading: false,
  data: {
    ...action.data
  }
});

const fetchReviewFail = (state) => ({
  ...state,
  loading: false
});

const setLocationCode = (state, action) => ({
  ...state,
  locationCode: action.locationCode
});

const reviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_REVIEWS_REQUEST:
      return fetchReviewRequest(state);

    case actionTypes.FETCH_REVIEWS_SUCCESS:
      return fetchReviewSuccess(state, action);

    case actionTypes.FETCH_REVIEWS_FAILURE:
      return fetchReviewFail(state);

    case actionTypes.SET_LOCATION_CODE:
      return setLocationCode(state, action);

    default:
      return state;
  }
};

export default reviewReducer;
